import { AnimatePresence, motion } from 'framer-motion'
import MD5 from 'md5'
import React, { Fragment, useEffect, useRef, useState } from 'react'
import { useQuery } from 'react-query'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import { getComingCourse } from '@/api/center'
import picEmpty from '@/assets/images/pic_empty.png'
import ClassItem from '@/components/ClassItem'
import ImgPlaceholder from '@/components/ImgPlaceholder'
import Loadding from '@/components/Loadding'
import { centerStore, useRecoilState, useRecoilValue } from '@/store'
const { userState } = centerStore

export default function Index() {
  const [course, setCourse] = useState<any>({})
  const user = useRecoilValue(userState)

  const { isFetching, data } = useQuery(['getComingCourse', user.id], (props) => {
    const timestamp = (Date.now() / 1000).toFixed(0)
    console.log('props.queryKey', props.queryKey)
    if (props.queryKey[1] && localStorage.visitorId) {
      return getComingCourse({
        userId: props.queryKey[1],
        sign: MD5(`userId=${props.queryKey[1]}&timestamp=${timestamp}&key=${import.meta.env.VITE_APP_userSecretKey}`),
        timestamp,
        uniqueDeviceNo: localStorage.visitorId
      })
    }
  })

  useEffect(() => {
    if (data && data.status === 0) {
      setCourse(data.data)
    }
  }, [data])

  return (
    <Container initial={{ opacity: 0, scale: 0.98 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.98 }} className="flex justify-center items-start relative">
      <Loadding state={isFetching}>
        {course.id ? (
          <ClassItem data={course} />
        ) : (
          <div className="w-full h-full flex items-center justify-center flex-col">
            <ImgPlaceholder className="w-[100px]" src={picEmpty} />
            <span className="text-[14px] text-[#999]">暂无数据</span>
          </div>
        )}
      </Loadding>
    </Container>
  )
}

const Container = styled(motion.div)`
  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
  padding: 30px;
  background-color: #fff;
  border-radius: 6px;
  .btn-style {
    background: linear-gradient(39deg, #ff742f 0%, #ff3300 100%);
  }
  .class-modal {
    width: 450px;
    padding: 0 0 20px 0;
    border-radius: 0;
  }
`
